export default __webpack_public_path__ + "static/restauration_cover_mobile-1-fd038caed80e89509ca5318e7e27e7d2.jpg";